import React from "react"
import Layout from "../shared/components/organisms/layout/layout"
import Content404 from "../shared/components/organisms/content-404/content-404"
import { siteUrl } from "../shared/utils/siteUrl"

class NotFoundPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      mobile: false,
    }
    if ("undefined" !== typeof window) {
      if (window.location.pathname.includes("//")) {
        window.location.href =
          siteUrl + window.location.pathname.replace(/\/\//g, "/")
      }
    }
  }

  componentDidMount() {
    if (window.innerWidth < 1024) {
      this.setState({
        mobile: true,
      })
    }

    window.addEventListener("resize", this.updateDimensions)
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      'event': 'pageError',
      'eventTrigger': 'pageError',
      'eventCategory': 'Page Error',
      'eventAction': 'Error 404', //this have to be dynamically pushed.
      'eventLabel': window.location.href, //this have to be dynamically pushed.
    });
    
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions)
  }

  updateDimensions = () => {
    if (window.innerWidth < 1024) {
      this.setState({
        mobile: true,
      })
    } else {
      this.setState({
        mobile: false,
      })
    }
  }

  render() {
    return (
      <Layout title='404 content' mobile={this.state.mobile}>
        <Content404 />
      </Layout>
    )
  }
}

export default NotFoundPage
